import logo from "./logo.svg";
import { useEffect, useState, useRef } from "react";
import "./App.css";
import "./assests/css/style.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  useSearchParams,
} from "react-router-dom";

import { AnimatePresence, motion } from "framer-motion";
import LoginPage from "./LoginPage";
import OtpPage from "./OtpPage";
import Questionnaire from "./Questionnaire";
import ImgUpload from "./ImgUpload";
import ProductDetls from "./ProductDetls";
import ProfilePage from "./ProfilePage";
import Result from "./Result";
import Termsncond from "./Termsncond";
import Onboarding from "./Onboarding";
import CameraPreview from "./CameraPreview";
import Resultnew from "./Resultnew";
import OnBoardingSlider from "./OnBoardingSlider";
import TakePhotoTop from "./TakePhotoTop";
import TakePhotoFront from "./TakePhotoFront";
import TakePhotoBack from "./TakePhotoBack";
import TakePhotoLeft from "./TakePhotoLeft";
import TakePhotoRight from "./TakePhotoRight";
import TakePhotoGallery from "./TakePhotoGallery/TakePhotoGallery";
import RegisterShortReport from "./RegisterShortReport";
import AssessmentReport from "./AssessmentReport";
import Reports from "./Reports";
import HealthAssessment from "./HealthAssessment";
import CompleteProfile from "./CompleteProfile.";
import Prescription from "./Prescription";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import translationText from "./Translations";
// dot navigation section import
import DotNavigation from "./components/DotNavigation";
import FeedBackForm from "./components/FeedbackForm";

import { useSelector, useDispatch } from "react-redux";
import {
  setbackview,
  setfrontview,
  settopview,
  setleftview,
  setrightview,
} from "./Reducers/reducer";
import { replace, useNavigate } from "react-router-dom";
import AlertComp from "./Alert";
import HeadCapture from "./HeadCapture";
import CartPage from "./components/CartPage";
import LoginShopifyUser from "./LoginShopify";
import imageCompression from "browser-image-compression";
import WebHeader from "./components/WebHeader";
import Aloxa from "./Aloxa";
import imgurl from "./assests/images/imgurl";

import DesktopLandingSection from "./DesktopLandingSection";
import { clearImagesInRedux } from "./utils/UtilityFunctions";
import Footer from "./components/Footer";
import PrescriptionList from "./PrescriptionList";
import UserPrescription from "./UserPrescription";
import LandingMiddlePage from "./components/LandingMiddlePage";
import CookieConsent from "./components/CookieConsent";
import MobileHeader from "./components/MobileHeader";
import Preview from "./Preview";
import TutorialVideo from "./components/TutorialVideo";
import GenerateQr from "./GenerateQr";
import ProtectedRoute from "./ProtectedRoute";
import ALQIQuestionnaire from "./ALQIQuestionnaire";
import SatisfactionQuestionnaire from "./SatisfactionQuestionnaire";
import HealthDeclaration from "./HealthDeclaration";
import C1 from "./promos/C1";
import QRCode from './QRCode';
import StartTest from "./promos/StartTest";


function App() {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [from, setFrom] = useState(null)
  const prevLocation = useRef(null);
  const scrollRef = useRef(null)
  const [activeSection, setActiveSection] = useState("section0");
  const [isMobile, setIsMobile] = useState(false);
  const [takeTest, setTakeTest] = useState(false)
  const [goTo, setGoTo] = useState('home')
  const locale = useSelector((state) => state.language.langData);
  // const isFeedbackPage = location.pathname === "/feedback";

  useEffect(() => {
    const a = true;
    if (a) {
      console.log = () => {};
    }
  }, [])

  useEffect(() => {
    const div = scrollRef.current;

    const handleScroll = () => {
      const scrollTop = div.scrollTop;
      const clientHeight = div.clientHeight;

      // offset to make section switch a bit earlier (e.g. 20% of fold)
      const offset = clientHeight * 0.2;

      // Adjusted fold calculation
      const foldIndex = Math.floor((scrollTop + offset) / clientHeight);

      switch (foldIndex) {
        case 0:
          setActiveSection("SECTION0");
          break;
        case 1:
          setActiveSection("SECTION1");
          break;
        case 2:
          setActiveSection("SECTION2");
          break;
        case 3:
          setActiveSection("SECTION3");
          break;
        default:
          setActiveSection("SECTION3");
          break;
      }
    };

    div.addEventListener("scroll", handleScroll);
    return () => div.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (!window.cordova) {
      let isMobile = /iPhone|iPod|iPad|Android/i.test(navigator.userAgent);
      if (!isMobile) {
        setIsMobile(false);
        setTakeTest(false)
      } else {
        setIsMobile(true);
        setTakeTest(true)
      }
    }
  }, []);

  useEffect(() => {
    let nowLocation = location
    console.log("nowLocation", nowLocation);
    // if(nowLocation.pathname === '/c1') {
    //   navigate('/start-test')
    // } else {
    //   return
    // }
  }, [location]);

  useEffect(() => {
    const hash = window.location.hash;
    const queryString = hash.split("?")[1];
    let checkUserData = JSON.parse(sessionStorage.getItem("checkUser"));
    if (queryString) {
      const queryParams = new URLSearchParams(queryString);
      if(queryParams.get("from")){
        window.location.href = window.location.href.split('?')[0]
      } else if(!queryParams.get("from") && checkUserData) {
        navigate("/taketest");
      }
    }
  }, [window.location.href]);

  useEffect(() => {
      i18next.init().then(() => {
      i18next.addResources(locale, "translation", translationText[locale]);
      i18next.changeLanguage(locale || "en").then(() => {});
    });
  }, [locale]);

  let user = localStorage.getItem("valid_user");

  const [alertopen, setalertopen] = useState(false);
  const [alertmsg, setalertmsg] = useState("progress");

  let { Topview, Backview, Leftview, Rightview, Frontview } = useSelector(
    (state) => state.user.profile
  );

  //  scroll section useRef dot navigation
  const sectionRefs = {
    section0: useRef(null),
    section1: useRef(null),
    section2: useRef(null),
    section3: useRef(null),
  };

  const scrollTo = (ref, section) => {
    setActiveSection(section);
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleArrow = (to) => {
    let goTo = to
    if(to === "home"){
      setGoTo("how-it-works")
      setActiveSection("section1")
    } else if(to === "how-it-works"){
      setGoTo("sample-report-review")
      setActiveSection("section2")
    } else if(to === "sample-report-review"){
      setGoTo("desktopLanding")
      setActiveSection("section3")
    } else if(to === "desktopLanding"){
      setGoTo("home")
      setActiveSection("section0")
    }
    const element = document.getElementById(goTo);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" }); // Smooth scroll
    }
    return(
      <DotNavigation
        sectionRefs={sectionRefs}
        activeSection={activeSection}
      />
    )
  }

  return (
    <div className="App" ref={scrollRef}>
      <AnimatePresence>
        {
          location.pathname != '/c1' &&
            <div className="d-none desktop-header">
              <WebHeader></WebHeader>
            </div>
        }

        <>
          <div className={isMobile ? "DesktopWebDiv mobile-view" : "DesktopWebDiv"} ref={sectionRefs.section0}>
            <div className={location.pathname != '/c1' ? "w-100 mainWrapper promopages" : "w-100 promopages"}>
              {/* {isMobile && !takeTest && <MobileHeader></MobileHeader>} */}

              {!isMobile && !takeTest && location.pathname != '/c1' && (
                <DesktopLandingSection></DesktopLandingSection>
              )}

              <div className={location.pathname != '/c1' && isMobile ? "mobileSectionsDiv" : "mobileSectionsDiv desktopBg"}>
                <div className={isMobile ? "" : "mobileholderdiv"}>
                  <Routes location={location} key={location.pathname}>
                    <Route 
                      path="/loginpage" 
                      element={<ProtectedRoute element={<LoginPage/>}/>}
                    />
                    <Route 
                      path="/otppage" 
                      element={<ProtectedRoute element={<OtpPage/>}/>}
                    />
                    {/* take photo image upload */}
                    <Route 
                      path="/taketest"
                      element={<ProtectedRoute element={<ImgUpload/>}/>}
                      // element={<ProtectedRoute user={sessionStorage.getItem('checkUser')} element={<ImgUpload/>}/>} 
                    />
                    {/* Reports list page */}
                    <Route 
                      path="/reports" 
                      element={<ProtectedRoute element={<Reports/>}/>}
                      // element={<ProtectedRoute user={sessionStorage.getItem('checkUser')} element={<Resultnew/>}/>} 
                    />
                    {/* Assessment Full Report page */}
                    <Route 
                      path="/report" 
                      element={<ProtectedRoute element={<Resultnew/>}/>}
                      // element={<ProtectedRoute user={sessionStorage.getItem('checkUser')} element={<Resultnew/>}/>} 
                    />
                    {/* Aloxa module */}
                    <Route 
                      path="/aloxa" 
                      element={<ProtectedRoute user={sessionStorage.getItem('checkUser')} element={<Aloxa/>}/>} 
                    />
                    {/* promo routes starts */}
                    <Route
                      path="/start-test"
                      element={<StartTest/>}
                    />
                    <Route
                      path="/c1"
                      element={<C1/>}
                    />
                    {/* promo routes ends */}

                    {/* tutorial page */}
                    <Route
                      path="/tutorial"
                      element={<TutorialVideo/>}
                      // element={<ProtectedRoute user={sessionStorage.getItem('checkUser')} element={<TutorialVideo/>}/>}
                    />
                    {/* new preview page */}
                    <Route
                      path="/preview"
                      element={<ProtectedRoute element={<Preview/>}/>}
                      // element={<ProtectedRoute user={sessionStorage.getItem('checkUser')} element={<Preview/>}/>}
                    />
                    {/* health declaration page */}
                    <Route
                      path="/healthdeclaration"
                      element={<ProtectedRoute element={<HealthDeclaration/>}/>}
                      // element={<ProtectedRoute user={sessionStorage.getItem('checkUser')} element={<Preview/>}/>}
                    />
                    {/* prescriptions list page */}
                    <Route
                      path="/prescriptions"
                      element={<ProtectedRoute element={<PrescriptionList/>}/>}
                      // element={<ProtectedRoute user={sessionStorage.getItem('checkUser')} element={<Preview/>}/>}
                    />
                    {/* user prescription page */}
                    <Route
                      path="/userprescription"
                      element={<ProtectedRoute element={<UserPrescription/>}/>}
                      // element={<ProtectedRoute user={sessionStorage.getItem('checkUser')} element={<Preview/>}/>}
                    />
                    {/* feedback page */}
                    <Route
                      path="/satisfaction-questionnaire"
                      element={<ProtectedRoute element={<SatisfactionQuestionnaire/>}/>}
                      // element={<ProtectedRoute user={sessionStorage.getItem('checkUser')} element={<Preview/>}/>}
                    />
                    {/* qr code generator page */}
                    <Route
                      path="/qrcode"
                      element={<QRCode/>}
                      // element={<ProtectedRoute user={sessionStorage.getItem('checkUser')} element={<Preview/>}/>}
                    />
                    <Route
                      path="/"
                      // element={
                      //   isMobile ? 
                      //     <ProtectedRoute element={<C1/>} nopromo={true} routeUrl="/c1"/>
                      //       :
                      //     <ProtectedRoute element={<StartTest/>} nopromo={true} routeUrl="/start-test"/>
                      // }
                      element={
                        <ProtectedRoute element={<StartTest/>} nopromo={true} routeUrl="/start-test"/>
                      }
                    />
                  </Routes>
                </div>
              </div>

              {/* {
                location.pathname != '/c1' &&
                  <span className="d-none dotNavigationSection">
                    <DotNavigation
                      sectionRefs={sectionRefs}
                      onDotClick={scrollTo}
                      activeSection={activeSection}
                      scrollRef={scrollRef}
                    />
                  </span>
              } */}
            </div>

            {/* {!isMobile && location.pathname != '/c1' && (
              <div className="arrowDivSection cursor-pointer">
                <img
                  className={goTo === "desktopLanding" && "upArrow"}
                  src={imgurl.ArrowGif}
                  onClick={() => handleArrow(goTo)}
                ></img>
              </div>
            )} */}
            {/* {!takeTest && location.pathname != '/c1' && <LandingMiddlePage sectionRefs={sectionRefs} />} */}
            {location.pathname === '/c1' && <CookieConsent />}
          </div>
        </>
      </AnimatePresence>
      {!takeTest && location.pathname != '/c1' && <Footer />}
      <AlertComp open={alertopen} msg={alertmsg} type={"success"} />
    </div>
  );
}

export default App;
